export class ShippingMessage extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.sectionId = 'shipping-message'
    this.updateShippingMessage = this.updateShippingMessage.bind(this)
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.updateShippingMessage,
    )
  }

  async fetchShippingMessage () {
    const url = `${window.location.pathname}?section_id=${this.sectionId}`
    const response = await fetch(url)
    const text = await response.text()

    if (text) {
      return new DOMParser().parseFromString(text, 'text/html')
    }

    return null
  }

  async updateShippingMessage () {
    try {
      const html = await this.fetchShippingMessage()
      const shippingNode = html.querySelector(this.els.shipping.selector)
      const currentShippingNode = this.els.shipping.element

      if (shippingNode && currentShippingNode) {
        currentShippingNode.replaceWith(shippingNode)
      }
    } catch (e) {
      console.info('unable to update shipping message')
    }
  }
}

if (!customElements.get('shipping-message')) {
  customElements.define('shipping-message', ShippingMessage)
}
